import { call, put } from "redux-saga/effects";
import { createTerritoryFailure, createTerritorySuccess, deleteTerritoryFailure, deleteTerritorySuccess, getTerritoryFailure, getTerritorySuccess, updateTerritoryFailure, updateTerritorySuccess } from "../../../Slices/territorySlice";
import { createTerritory, deleteTerritory, getTerritories, updateTerritory } from "../../../../Services/apiService";

export function* getTerritoryHandler(actions) {
    try {
        const response = yield call(getTerritories, actions?.payload);
        yield put(getTerritorySuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(getTerritoryFailure(errResponse))
    }
}

export function* createTerritoryHandler(actions) {
    try {
        const response = yield call(createTerritory, actions?.payload);
        yield put(createTerritorySuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(createTerritoryFailure(errResponse))
    }
}

export function* updateTerritoryHandler(actions) {
    try {
        const response = yield call(updateTerritory, actions?.payload);
        yield put(updateTerritorySuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(updateTerritoryFailure(errResponse))
    }
}

export function* deleteTerritoryHandler(actions) {
    try {
        const response = yield call(deleteTerritory, actions?.payload);
        yield put(deleteTerritorySuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(deleteTerritoryFailure(errResponse))
    }
}